// cleanSlate product tabs. CSP-safe (wired via addEventListener — no inline
// onclick="..." like the design mock). Mirrors the mock's initTabs, but keyed
// on data hooks instead of ids (cleanSlate convention): each tab button carries
// data-zit-tab="<alias>" and each panel data-zit-tab-panel="<alias>". Clicking a
// tab marks it active (.zit-cs-active, == behaviors.activation.stateClass) and
// shows only the matching panel by toggling Tailwind's `hidden`.
export default function initTabs() {
	const tabStrips = document.querySelectorAll('.zit-cs-tabs');

	tabStrips.forEach(function (strip) {
		const tabs = strip.querySelectorAll('[data-zit-tab]');

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				const target = tab.dataset.zitTab;

				// activate the clicked tab within its strip
				tabs.forEach(function (t) {
					t.classList.remove('zit-cs-active');
				});
				tab.classList.add('zit-cs-active');

				// show only the panel whose alias matches the clicked tab.
				// Panels are siblings of the strip (not inside it), so query the
				// page; one tab strip per product page makes this unambiguous.
				const panels = document.querySelectorAll('[data-zit-tab-panel]');
				panels.forEach(function (panel) {
					panel.classList.toggle('hidden', panel.dataset.zitTabPanel !== target);
				});
			});
		});
	});
}
